module.exports = __webpack_public_path__ + "static/img/danfe.eefcff9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/danfe.jpg
// module id = pQ1x
// module chunks = 1